(function ($) {
  Drupal.behaviors.basicImageFlipOnHoverV1 = {
    attach: function (context, settings) {
      var hasTouch = 'ontouchstart' in window,
        flipOnHoverFormatter = $('.basic-image-flip', context);

      $('.js-flip-on-hover-enabled--v1', context).each(function () {
        var thisFormatter = $(this);

        if (thisFormatter.hasClass('js-flip-on-hover-disabled--v1')) {
          return false;
        }
        flipBackContainer = thisFormatter.find('.flip-back');
        flipFrontContainer = thisFormatter.find('.flip-front');
        flipBackContainer.on('click', function (event) {
          event.stopPropagation();
          event.cancelBubble = true;
          $(this).siblings('a').get(0).trigger('click');

          return false;
        });
      });

      // Flip-On-Hover
      if (hasTouch) {
        // Only handle click for touch devices
        flipOnHoverFormatter.on('click', '.flip-front', function () {
          flipOnHoverFormatter.find('.flip').removeClass('flipped');
          $(this).parent().find('.flip').addClass('flipped');
        });
      } else {
        // Only handle mouse over/out events for non-touch devices
        flipOnHoverFormatter
          .on('mouseenter', function (event) {
            $(this).find('.flip').addClass('flipped');
          })
          .on('mouseleave', function (event) {
            $(this).find('.flip').removeClass('flipped');
          });
      }

      // Detect CSS transform  support
      if ($.browser.msie && parseInt($.browser.version, 10) === 8 || $.browser.msie && parseInt($.browser.version, 10) === 9) {
        flipOnHoverFormatter.addClass('no-csstransforms3d');
      }
    }
  };
})(jQuery);
